var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"#237076","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("Axcess1 © 2020")])])}
var staticRenderFns = []

export { render, staticRenderFns }